/**
 * DOM utilities to use native browser capabilities and avoid dependencies.
 *
 * @module dom.dom-util
 * @version 1.0.0
 * @since Fri Nov 20 2015
 */

/**
 * Native DOM ready function.
 *
 * @param  {Function} callback
 */
exports.ready = (callback) => {
  /* Removing the listener from dom to avoid multiple bindings */
  document.removeEventListener("DOMContentLoaded", callback)
  document.addEventListener("DOMContentLoaded", callback, false)
}

/**
 * Native querySelectorAll to find all the dom element with given selector.
 *
 * @param  {String | Object} selector Target selector element.
 * @param  {String | Object} context  Context/parent element, if it not provided
 * fallback to document.
 * @return {nodeList | Array} Returns the target as a DOM node.
 */
exports.findAll = (selector, context) => {
  return (context || document).querySelectorAll(selector)
}

/**
 * Find closest element based of element, selector
 *
 * @param {Object} el This is HTML element.
 * @param {String} selector This will be used as selector for closest element
 * element.
 * @param {string} stopSelector optional; if we want to search till which element
 * @return {Boolean} Returns true/false
 */

exports.closest = (el, selector, stopSelector) => {
  let retval = null
  while (el) {
    if (this.hasClass(el, selector)) {
      retval = el
      break
    } else if (stopSelector && this.hasClass(el, stopSelector)) {
      break
    }
    el = el.parentElement // eslint-disable-line no-param-reassign
  }
  return retval
}

/**
 * Checks if the queried id existance on the parent nodes.
 *
 * @param {Object} el This is HTML element.
 * @param {String} id This will be used as id selector for parent
 * element.
 * @return {Boolean} Returns true/false
 */
exports.hasParent = (ele, id) => {
  if (!ele) return false
  let el = ele.target || ele.srcElement || ele || false
  while (el && el.id !== id) {
    el = el.parentNode || false
  }
  return el !== false
}

/**
 * Native querySelector to find first element in the dom with given selector
 *
 * @param  {String | Object} selector Target selector element.
 * @param  {String | Object} context  Context/parent element, if it not provided
 * fallback to document.
 * @return {Object} returns the target as a DOM node
 */
exports.findFirst = (selector, context) => {
  return (context || document).querySelector(selector)
}

/**
 * Checks for classList native support.
 *
 * @return {Boolean} Returns true/false.
 */
function checkClassListSupport() {
  return "classList" in document.documentElement
}

/**
 * Find closest element based of element, selector
 *
 * @param {Object} el This is HTML element.
 * @param {String} selector This will be used as selector for closest element
 * element.
 * @param {string} stopSelector optional; if we want to search till which element
 * @return {Boolean} Returns true/false
 */

exports.closest = (el, selector, stopSelector) => {
  let retval = null
  while (el) {
    if (this.hasClass(el, selector)) {
      retval = el
      break
    } else if (stopSelector && this.hasClass(el, stopSelector)) {
      break
    }
    el = el.parentElement // eslint-disable-line no-param-reassign
  }
  return retval
}

/**
 * Checks if the queried id existance on the parent nodes.
 *
 * @param {Object} el This is HTML element.
 * @param {String} id This will be used as id selector for parent
 * element.
 * @return {Boolean} Returns true/false
 */
exports.hasParent = (ele, id) => {
  if (!ele) return false
  let el = ele.target || ele.srcElement || ele || false
  while (el && el.id !== id) {
    el = el.parentNode || false
  }
  return el !== false
}

/**
 * Checks if the queried classname existance on the element.
 *
 * @param {Object} el This is HTML element.
 * @param {String} className This will be used a new style class added to the
 * element.
 * @return {Boolean} Returns true/false
 */
exports.hasClass = (el, className) => {
  const classListSupport = checkClassListSupport()

  // check if the element is not null and classList is supported
  if (el && classListSupport) {
    return el.classList.contains(className)
  }

  // fallback for non-classlist supported browsers
  if (el && !classListSupport) {
    return new RegExp(`\\b${className}\\b`).test(el.className)
  }
  return null
}

/**
 * Adds style class to the supplied element.
 *
 * @param {Object} el This is HTML element.
 * @param {String} className This will be used as a style class to be added to
 * the element.
 */
exports.addClass = (el, className) => {
  const classListSupport = checkClassListSupport()

  // check if the element is not null and classList is supported
  if (el && classListSupport) {
    el.classList.add(className)
  }

  // fallback for non-classlist supported browsers
  if (el && !classListSupport && !exports.hasClass(el, className)) {
    el.className += ` ${className}`
  }
}

/**
 * Removes style class from the supplied element.
 *
 * @param {Object} el This is HTML element.
 * @param {String} className This will be used as a style class to be removed
 * from the element.
 */
exports.removeClass = (el, className) => {
  const classListSupport = checkClassListSupport()

  // check if the element is not null and classList is supported
  if (el && classListSupport) {
    el.classList.remove(className)
  }

  // fallback for non-classlist supported browsers
  if (el && !classListSupport) {
    el.className = el.className.replace(
      new RegExp(`\\b${className}\\b`, "g"),
      ""
    )
  }
}

exports.removeAllClasses = (el) => {
  el.className = ""
}

/**
 * Based on the browser test stats form below URL, for loop is much faster than
 * any other implementation, if we catch the variables, so this below utility
 * method will help avoiding lodash dependency
 * https://jsperf.com/angular-foreach-vs-native-for-loop/29
 *
 * @param  {Array}   array
 * @param  {Function} callback
 */
exports.forEach = (array, callback) => {
  let i
  const { length } = array

  for (i = 0; i < length; i++) {
    const ele = array[i]

    // callback with element as a parameter
    callback(ele)
  }
}
